import { api, BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('accounts/authentication');
  }
  login = async (data: object) => {
    return await api.post(this.buildUrl('login'), data);
  };
}

export default new API();
